import { Injectable } from '@angular/core';
import { StorageService } from '../../services/storage/storage.service';
import { ConfigService } from '../../services/config/config.service';
import { HttpClient } from '@angular/common/http';
import { Definitions } from '../../core/definitions';
import { ApiResponse } from '../../services/api-response.interface';
import { SearchService } from '../../services/search/search.service';
import { map } from 'rxjs/operators';
import { RangeField } from '../../core/interfaces/search.interface';

export interface IAdvancedSearchResponse {
  hitsCount: number;
  filterLabel: string;
  resourceLabel: string;
  expandedAdvancedSearchBoxesByDefault: string;
  enableTypeAhead: boolean;
  filters: IFilters[];
}

export interface IFilters {
  filterId: number;
  title: string;
  filterIndex: string;
  dropdownFields: IDropdownField[];
  rangeFields?: RangeField[];
}

export interface IDropdownField {
  index: string;
  name: string;
  value: string;
  count: string;
  selected: string;
}

export interface IAdvancedSearchRequest {
  matches: IMatch[];
  filters: IFilter[];
  resources: number[];
}

export interface IMatch {
  index: string;
  matchJoinOperator: string;
  query: string;
  queryOption: string;
}

export interface IFilter {
  dateItemsAdded: string[];
  lexile: string[];
  awards: string[];
  forAudiences: string[];
  formats: string[];
  interestLevels: string[];
  languages: string[];
  materialTypes: string[];
  pointLevels: string[];
  pubYears: string[];
  readingLevels: string[];
  scopingLevel: number;
}

@Injectable()
export class AdvancedSearchService extends Definitions {
  constructor(
    private storageService: StorageService,
    private configService: ConfigService,
    private _http: HttpClient,
  ) {
    super();
  }

  async getDefaultAvailableFiltersAsync() {
    const resources = this.storageService.getItem('availableResources');
    const defaultSelectedResources = SearchService.getSelectResources(resources);
    const requestBody = {
      searchQuery: { matches: [], filters: {}, resources: defaultSelectedResources },
    };
    await this.getFiltersAsync(requestBody);
  }

  async getFiltersAsync(requestBody) {
    return await this.getAvailableFilters(requestBody).toPromise();
  }

  getAvailableFilters(data) {
    const url = `${this.configService.searchApi}/search/AdvancedFilters`;
    return this._http.post<ApiResponse<IAdvancedSearchResponse>>(url, data).pipe(
      map((response) => {
        if (response && response.message.toLowerCase() == 'success') {
          return response.data;
        }
      }),
    );
  }
}
